import { getApiErrorMessage } from "./getApiErrorMessage";
import { translateInventoryApiMessage } from "./translateInventoryApiMessage";
import { translateRbacApiMessage } from "./translateRbacApiMessage";

/**
 * User-facing API error for tenant UI (stores, branches, inventory, etc.) with EN/AR i18n.
 * @param {unknown} err
 * @param {import('i18next').TFunction} t
 * @param {string} fallbackKey - i18n key when no API message is available
 * @returns {string}
 */
export function resolveTenantApiError(err, t, fallbackKey) {
  const raw = getApiErrorMessage(err);
  const fromInventory = raw ? translateInventoryApiMessage(raw, t) : "";
  if (fromInventory) return fromInventory;
  const fromRbac = raw ? translateRbacApiMessage(raw, t) : "";
  if (fromRbac && fromRbac !== raw) return fromRbac;
  if (raw) return raw;
  return t(fallbackKey);
}
